<template>
  <div>
    <span>{{ second }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      duration: {
        type: [String, Number],
        default: ''
      }
    },

    data() {
      return {
        timer: 0,
        second: 0
      }
    },

    watch: {
      timer: {
        handler: function() {
          ++this.second
        },
        immediate: true
      }
    },

    mounted() {
      if(this.second==1) {
        this.second = this.duration
      }
      setInterval( () => {
        ++this.timer
      },1000)
    }
  }
</script>
